import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// material
import { Box } from '@mui/material';
// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  return (
    <Link to="/">
      <Box component="img" src="/logo.png" sx={{ width: 40, height: 40, ...sx }} />
    </Link>
  );
}
